import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { MODAL_LEAD_FORMS_EMPTY_TEXT } from "../../i18n/keysTranslations";
import { useTranslationApp } from "../../lib/i18next";

export const LeadFormsList = ({
  leadForms = [],
  selectedItem,
  onChangeSelectedItem,
  lastItemRef,
}) => {
  const { t } = useTranslationApp();

  const leadFormsSorted = leadForms.sort(
    (a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0)
  );

  if (leadForms.length === 0) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: 200,
        }}
      >
        <Typography variant="body2" color="text.secondary">
          {t(MODAL_LEAD_FORMS_EMPTY_TEXT)}
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <RadioGroup
        value={selectedItem || ""}
        onChange={(e) => onChangeSelectedItem(e.target.value)}
      >
        {leadFormsSorted.map((leadForm, index) => {
          if (index === leadForms.length - 1) {
            return (
              <FormControlLabel
                key={leadForm.id}
                value={leadForm.id}
                control={<Radio />}
                label={
                  <Box
                    ref={lastItemRef}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 0.5,
                    }}
                  >
                    <Typography variant="body1">{leadForm.name}</Typography>
                    {leadForm.description && (
                      <Typography variant="body2" color="text.secondary">
                        {leadForm.description}
                      </Typography>
                    )}
                  </Box>
                }
                sx={{
                  width: "100%",
                  mb: 1,
                  "& .MuiFormControlLabel-label": {
                    width: "100%",
                  },
                }}
              />
            );
          }

          return (
            <FormControlLabel
              key={leadForm.id}
              value={leadForm.id}
              control={<Radio />}
              label={
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 0.5,
                  }}
                >
                  <Typography variant="body1">{leadForm.name}</Typography>
                  {leadForm.description && (
                    <Typography variant="body2" color="text.secondary">
                      {leadForm.description}
                    </Typography>
                  )}
                </Box>
              }
              sx={{
                width: "100%",
                mb: 1,
                "& .MuiFormControlLabel-label": {
                  width: "100%",
                },
              }}
            />
          );
        })}
      </RadioGroup>
    </Box>
  );
};
